import { render } from "./CustomersOrdersCard.vue?vue&type=template&id=aa7e8e04&scoped=true"
import script from "./CustomersOrdersCard.vue?vue&type=script&lang=js"
export * from "./CustomersOrdersCard.vue?vue&type=script&lang=js"

import "./CustomersOrdersCard.vue?vue&type=style&index=0&id=aa7e8e04&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa7e8e04"]])

export default __exports__